module.exports = __webpack_public_path__ + "static/media/star-half-alt.f38d5eca.svg";